(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('.luciano-product').forEach(root => {
      if (root.dataset.lucianoReady) return;
      root.dataset.lucianoReady = 'true';
      const form = root.querySelector('[data-luciano-product-form]');
      const sticky = root.querySelector('[data-luciano-sticky-buy]');
      const offerLink = root.querySelector('[data-luciano-offer-link]');
      offerLink?.addEventListener('click', event => {
        if (!form) return;
        event.preventDefault();
        form.scrollIntoView({block:'center', behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        form.focus({preventScroll:true});
      });
      if (form && sticky && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => {
          sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        }, {threshold:0});
        observer.observe(form);
        const unload = event => {
          if (!event.target.contains(root)) return;
          observer.disconnect();
          document.removeEventListener('shopify:section:unload', unload);
        };
        document.addEventListener('shopify:section:unload', unload);
      }
      root.querySelectorAll('[data-luciano-deadline]').forEach(timer => {
        timer.hidden = true;
        const fixed = (timer.dataset.lucianoDeadline || '').trim();
        const daily = !fixed && timer.dataset.lucianoDailyReset === 'true';
        let clock;
        if (daily) {
          try {
            clock = new Intl.DateTimeFormat('en-US', {timeZone:timer.dataset.lucianoTimezone || 'America/New_York', hourCycle:'h23', year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit', second:'2-digit'});
          } catch {return;}
        }
        const midnight = now => {
          const parts = instant => Object.fromEntries(clock.formatToParts(instant).filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
          const local = parts(now);
          const target = Date.UTC(local.year, local.month - 1, local.day + 1);
          let instant = target;
          for (let attempt = 0; attempt < 4; attempt++) {
            const current = parts(instant);
            const delta = target - Date.UTC(current.year, current.month - 1, current.day, current.hour, current.minute, current.second);
            if (!delta) return instant;
            instant += delta;
          }
          return NaN;
        };
        let deadline = daily ? midnight(Date.now()) : Date.parse(fixed);
        if (!Number.isFinite(deadline) || deadline <= Date.now()) return;
        const parts = ['days', 'hours', 'minutes', 'seconds'].map(part => timer.querySelector(`[data-time-part="${part}"]`));
        if (parts.some(part => !part)) return;
        let interval;
        let intersection;
        let inView = !('IntersectionObserver' in window);
        const stop = () => {clearInterval(interval); interval = undefined;};
        const dispose = () => {
          stop();
          intersection?.disconnect();
          document.removeEventListener('visibilitychange', refresh);
          document.removeEventListener('shopify:section:unload', unload);
        };
        const tick = () => {
          const now = Date.now();
          if (daily && deadline <= now) deadline = midnight(now);
          const remaining = Math.ceil((deadline - now) / 1000);
          if (!timer.isConnected || !Number.isFinite(remaining) || remaining <= 0) {
            timer.hidden = true;
            dispose();
            return false;
          }
          const values = [daily ? 0 : Math.floor(remaining / 86400), Math.floor((daily ? remaining : remaining % 86400) / 3600), Math.floor(remaining % 3600 / 60), remaining % 60];
          parts.forEach((part, index) => {
            const value = String(values[index]).padStart(2, '0');
            if (part.textContent !== value) part.textContent = value;
          });
          timer.hidden = false;
          return true;
        };
        const refresh = () => {
          stop();
          if (!document.hidden && inView && tick()) interval = setInterval(tick, 1000);
        };
        const unload = event => {
          if (event.target.contains(root)) dispose();
        };
        if (!tick()) return;
        document.addEventListener('visibilitychange', refresh);
        document.addEventListener('shopify:section:unload', unload);
        if ('IntersectionObserver' in window) {
          intersection = new IntersectionObserver(([entry]) => {inView = entry.isIntersecting; refresh();});
          intersection.observe(timer);
        } else refresh();
      });
      const gallery = root.querySelector('[data-luciano-gallery]');
      if (gallery) {
        const slides = [...gallery.querySelectorAll('[data-slide]')];
        const thumbs = [...gallery.querySelectorAll('[data-thumb]')];
        const previous = gallery.querySelector('[data-luciano-prev]');
        const next = gallery.querySelector('[data-luciano-next]');
        const rail = gallery.querySelector('.gallery-thumbs');
        const stage = gallery.querySelector('.gallery-stage');
        let active = 0;
        const select = index => {
          active = Math.max(0, Math.min(slides.length - 1, index));
          slides.forEach((slide, n) => {
            slide.hidden = n !== active;
            if (n !== active) slide.querySelectorAll('video').forEach(video => video.pause());
          });
          thumbs.forEach((thumb, n) => thumb.setAttribute('aria-pressed', String(n === active)));
          previous.disabled = active === 0;
          next.disabled = active === slides.length - 1;
          gallery.querySelector('[data-gallery-count]').textContent = `${active + 1} / ${slides.length}`;
          const thumb = thumbs[active];
          if (thumb) {
            const horizontal = matchMedia('(max-width: 760px)').matches;
            const offset = horizontal ? thumb.offsetLeft : thumb.offsetTop;
            const size = horizontal ? thumb.offsetWidth : thumb.offsetHeight;
            const position = horizontal ? rail.scrollLeft : rail.scrollTop;
            const viewport = horizontal ? rail.clientWidth : rail.clientHeight;
            if (offset < position || offset + size > position + viewport) {
              const destination = offset < position ? offset : offset + size - viewport;
              rail.scrollTo({[horizontal ? 'left' : 'top']: destination, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
            }
          }
        };
        previous.addEventListener('click', () => select(active - 1));
        next.addEventListener('click', () => select(active + 1));
        thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => select(index)));
        gallery.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          if (event.target.closest('video, iframe, model-viewer')) return;
          event.preventDefault();
          select(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : active + (event.key === 'ArrowRight' ? 1 : -1));
        });
        let touch;
        stage.addEventListener('touchstart', event => {touch = event.touches.length === 1 ? {x:event.touches[0].clientX,y:event.touches[0].clientY} : null;}, {passive:true});
        stage.addEventListener('touchend', event => {
          if (!touch || !event.changedTouches.length) return;
          const dx = event.changedTouches[0].clientX - touch.x;
          const dy = event.changedTouches[0].clientY - touch.y;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) select(active + (dx < 0 ? 1 : -1));
          touch = null;
        }, {passive:true});
        stage.addEventListener('touchcancel', () => {touch = null;}, {passive:true});
        if (slides.length < 2) gallery.querySelector('.luciano-gallery-arrows').hidden = true;
        select(0);
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
